<template>
  <div class="drawer-container" :class="{ 'drawer-container--open': drawerOpen }">
    <div class="drawer-container__backdrop" :class="{ 'drawer-container__backdrop--open': drawerOpen }" />
    <div class="drawer" :class="{ 'drawer--open': drawerOpen }">
      <div class="drawer__header" :class="{ 'drawer__header--open': drawerOpen }">
        <base-text v-if="title" class="serif-20">
          {{ title }}
        </base-text>
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="$emit('close')"
        >
          <base-icon icon="cancel" />
        </button>
      </div>
      <div class="drawer__content" :class="{ 'drawer__content--open': drawerOpen }">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseDrawer',
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    drawerOpen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  transition: transform 0.3s cubic-bezier(0, 0, 0.3, 1), -webkit-transform 0.3s cubic-bezier(0, 0, 0.3, 1);
  transform: translateX(-150%);
  /* both 'height' and 'top' properties are calculated based off of header height ($offsetTop) + 1px so there's a 1px
   distance between header and drawer. */
  height: calc(100vh - (#{$offsetTop} + 1px));
  background-color: white;
  position: fixed;
  width: 262px;
  top: calc(#{$offsetTop} + 1px);
  padding: 29px 21px 27px 24px;
  z-index: 1000;
  &--open {
    transform: translateX(0);
  }
  &__header {
    width: 100%;
    padding-bottom: 28px;
    justify-content: space-between;
    align-content: center;
    display: inline-flex;
    &--open {
      display: inline-flex;
    }
  }
  &__content {
    height: 100%;
    display: block;
    &--open {
      display: block;
    }
  }
}
.drawer-container {
  position: fixed;
  pointer-events: none;
  left: 0;
  &--open {
    pointer-events: all;
  }
  &__backdrop {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(black, 0.5);
    transition: 0.3s;
    pointer-events: none;
    opacity: 0;
    z-index: 999;
    &--open {
      opacity: 1;
    }
  }
}
.close {
  display: flex;
  align-content: center;
}
</style>
